/* Init filtering for the dodatki facet search input (text presentation only). */
(function() {
  var labelCache = new WeakMap();
  function normalizeString(value) {
    return (value || '')
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  function getLabelState(label) {
    if (!label) return null;
    var state = labelCache.get(label);
    if (!state) {
      var original = label.getAttribute('data-original-label') || label.textContent || '';
      state = {original: original, normalized: normalizeString(original), lower: original.toLowerCase(), rendered: null};
      labelCache.set(label, state);
      label.setAttribute('data-original-label', original);
    }
    return state;
  }
  function renderLabel(label, state, query) {
    if (!label || !state) return;
    var index = query ? state.lower.indexOf(query.toLowerCase()) : -1;
    var signature = index < 0 ? '' : index + ':' + query.length;
    if (state.rendered === signature) return;
    state.rendered = signature;
    if (index < 0) {
      if (label.childElementCount || label.textContent !== state.original) label.textContent = state.original;
      return;
    }
    var match = document.createElement('b');
    match.textContent = state.original.slice(index, index + query.length);
    label.replaceChildren(document.createTextNode(state.original.slice(0, index)), match,
      document.createTextNode(state.original.slice(index + query.length)));
  }

  function filterList(input) {
    var fieldset = input.closest('fieldset');
    if (!fieldset) return;
    var list = fieldset.querySelector('ul');
    if (!list) return;
    var query = normalizeString(input.value);
    var showMore = fieldset.querySelector('show-more-button');

    // When filtering, reveal all items and hide the show-more control.
    // The dynamic loader dispatches another input event after replacing the list,
    // so filtering the currently available items is safe while loading continues.
    if (query) {
      if (showMore) showMore.style.display = 'none';
      list.querySelectorAll('li.show-more-item.hidden').forEach(function(li){
        li.classList.remove('hidden');
      });
    } else {
      // Restore show-more state when query is cleared
      if (showMore) showMore.style.display = '';
    }
    var items = list.querySelectorAll('li.facets__item');
    for (var i = 0; i < items.length; i++) {
      var li = items[i];
      var labelEl = li.querySelector('.facet-checkbox__text-label');
      var state = getLabelState(labelEl);
      var text = state ? state.normalized : '';
      var isMatch = !query || text.indexOf(query) !== -1;
      var display = isMatch ? '' : 'none';
      if (li.style.display !== display) li.style.display = display;
      if (labelEl) {
        if (isMatch) {
          renderLabel(labelEl, state, input.value.trim());
        } else {
          renderLabel(labelEl, state, '');
        }
      }
    }

    // If query cleared, restore the original hidden class for items beyond the initial threshold
    if (!query) {
      list.querySelectorAll('li.facets__item').forEach(function(li){
        if (li.classList.contains('show-more-item')) {
          li.classList.add('hidden');
        } else {
          li.classList.remove('hidden');
        }
      });
    }
  }

  function onInput(e) {
    var target = e.target;
    if (!target || !target.classList || !target.classList.contains('facet-search-input')) return;
    filterList(target);
    e.stopPropagation();
  }

  function onKeydown(e) {
    var target = e.target;
    if (!target || !target.classList || !target.classList.contains('facet-search-input')) return;
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  // Attach global listeners (delegated) so it survives re-renders
  document.addEventListener('input', onInput, true);
  document.addEventListener('keydown', onKeydown, true);

  // Initialize immediately for existing inputs
  window.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.facet-search-input').forEach(function(input) {
      filterList(input);
    });
  });
})();


